import { Inbox, SearchX } from 'lucide-react'

/**
 * Empty state for tables and grids. Tells the user what this thing is and
 * offers the one action that fills it, instead of a bare "No results."
 *
 * Pages describe themselves through the table shells' `emptyState` prop:
 *   { icon, title, description, action }
 * where `action` is a ready-to-render element (usually a Button).
 */
const TableEmptyState = ({ icon: Icon = Inbox, title = 'Nothing here yet', description, action }) => (
    <div className="flex flex-col items-center justify-center py-10 px-4 text-center">
        <div className="w-14 h-14 bg-slate-50 rounded-full flex items-center justify-center mb-3 border border-slate-100">
            <Icon className="w-7 h-7 text-slate-300" aria-hidden="true" />
        </div>
        <h3 className="text-sm font-semibold text-slate-900 mb-1">{title}</h3>
        {description && <p className="text-sm text-slate-500 max-w-md font-normal whitespace-normal">{description}</p>}
        {action && <div className="mt-4">{action}</div>}
    </div>
)

/**
 * Shown when rows exist but the active search/filter matches none of them —
 * a different situation from "nothing exists yet" and labelled as such.
 */
export const FilterEmptyState = ({ searchTerm }) => (
    <TableEmptyState
        icon={SearchX}
        title="No matches"
        description={
            searchTerm
                ? `Nothing here matches "${searchTerm}". Try a shorter or different term.`
                : 'Nothing matches the current search. Try a shorter or different term.'
        }
    />
)

export default TableEmptyState
